export default {
  'app.title': 'RustDesk 控制台',
  'navBar.lang': '语言',
  'layout.user.link.help': '帮助',
  'layout.user.link.privacy': '隐私',
  'layout.user.link.terms': '条款',
  'app.preview.down.block': '下载此页面到本地项目',
  'app.welcome.link.fetch-blocks': '获取全部区块',
  'app.welcome.link.block-list': '基于 block 开发，快速构建标准页面',
  'The verification code is incorrect or has expired': '验证码错误或已超时',
  'If an account exists, a verification code has been sent.': '如果账户存在，验证码已发送。',
  'Failed to get verification code': '获取验证码失败',
  Type: '类型',
  Remote: '被控端',
  remoteTip: '远程被控制的电脑或其他终端',
  Local: '主控端',
  'Start Time': '开始时间',
  'End Time': '结束时间',
  Note: '备注',
  'Log List': '日志列表',
  'Device List': '设备列表',
  'User List': '用户列表',
  'User Name': '用户名',
  Updating: '正在更新',
  Adding: '正在添加',
  Deleting: '正在删除',
  Create: '创建',
  Add: '添加',
  Confirm: '确认',
  Submit: '提交',
  Warning: '注意',
  Error: '错误',
  Email: '电子邮箱',
  Status: '状态',
  Action: '动作',
  Password: '密码',
  'New Password': '新密码',
  Edit: '编辑',
  Normal: '正常',
  Disabled: '禁用',
  Disable: '禁用',
  Enable: '启用',
  Chosen: '选中',
  Items: '项',
  User: '用户',
  Info: '信息',
  'Log out': '退出登录',
  Settings: '设置',
  'Basic Settings': '基本设置',
  'Remote Desktop': '远程桌面',
  'File Transfer': '文件传输',
  'Port Transfer': '端口转发',
  'View Camera': '查看摄像头',
  'Terminal': '终端',
  'Not Logged In': '未登录',
  'Created Time': '创建时间',
  Delete: '删除',
  Group: '群组',
  'Device Group': '设备组',
  'User Group': '用户组',
  Name: '名称',
  'Group List': '群组列表',
  deleteConfirm: '确认要删除？',
  groupTip: '同一组用户可以相互访问',
  document: '文档',
  Detail: '详细信息',
  Direction: '方向',
  File: '文件',
  Directory: '目录',
  Disconnect: '断开连接',
  Time: '时间',
  'Export as csv': '导出csv',
  exportCsvTip: '一次最多导出1000条记录',
  'Not binded only': '只显示未绑定设备',
  Close: '关闭',
  'Default Strategy': '默认策略',
  'applied device num': '应用的设备数',
  'Device Name': '设备名称',
  'Strategy': '策略',
  'Device Strategy': '设备策略',
  'User Strategy': '用户策略',
  'Group Strategy': '设备组策略',
  'strategy_tooltip': "格式：\"设备策略 / 用户策略 / 设备组策略\"。单独显示 '-' 表示使用默认策略，某个位置显示 '-' 表示该级别未设置策略",
  Search: '搜索',
  Select: '挑选',
  Assign: '分配',
  Device: '设备',
  'Device Username': '设备用户名',
  Role: '角色',
  'Auth Type': '认证方式',
  Invite: '邀请',
  'Please configure Email SMTP settings first': '请先配置邮箱SMTP设置',
  'Security Settings': '安全设置',
  'Manage Signed Devices': '管理已签名的设备',
  'Since 2FA is enabled, the email login verification option is not used. 2FA login verification will be used instead.': '由于启用了2FA，电子邮件登录验证选项将不使用。将使用2FA登录验证代替。',
  'Enable alarm event email notification': '启用告警事件邮件通知',
  'Enable email login verification': '启用邮箱登录验证',
  'License Type': '许可证类型',
  'Renew / Upgrade License': '续费 / 升级许可证',
  Save: '保存',
  Back: '返回',
  'Confirm Password': '确认密码',
  'username@device_name': '用户名@设备名',
  'Hide username': '隐藏用户名',
  'Remote device': '被控设备',
  'Within-group connections': '群组内连接',
  'Cross-group connections': '跨群组连接',
  welcomeTitle: '欢迎使用 RustDesk',
  Cancel: '取消',
  OK: '确定',

  'pages.GroupList.User Group': '用户组',
  'pages.GroupList.User': '用户',

  'pages.CustomClient.Application name': '应用名称',
  'pages.CustomClient.Package name': '包名',
  'pages.CustomClient.Bundle identifier': 'Bundle 标识符',
  'pages.CustomClient.Server': '服务器',
  'pages.CustomClient.CPU Architecture': 'CPU 架构',
  'pages.CustomClient.Distribution': '发行版',
  'pages.CustomClient.Disable auto padding of application icon': '禁用应用图标自动填充',
  'pages.CustomClient.Name': '名称',
  'pages.CustomClient.Build': '构建',
  'pages.CustomClient.Note': '备注',
  'pages.CustomClient.Action': '动作',
  'pages.CustomClient.Delete': '删除',
  'pages.CustomClient.Edit': '编辑',
  'pages.CustomClient.Duplicate': '复制',
  'pages.CustomClient.Create': '创建',
  'pages.CustomClient.Custom Clients': '定制客户端',
  'pages.CustomClient.General': '通用',
  'pages.CustomClient.Name of the configuration': '配置名称',
  'pages.CustomClient.MSI installer': 'MSI 安装程序',
  'pages.CustomClient.Package format': '打包格式',
  'pages.CustomClient.Connection type': '连接类型',
  'pages.CustomClient.Bidirectional': '双向',
  'pages.CustomClient.Incoming': '入站 (Incoming)',
  'pages.CustomClient.Outgoing': '出站 (Outgoing)',
  'pages.CustomClient.Options': '选项',
  'pages.CustomClient.Disable installation': '禁用安装',
  'pages.CustomClient.Disable settings': '禁用设置',
  'pages.CustomClient.Disable address book': '禁用地址簿',
  'pages.CustomClient.Disable TCP listen port': '禁用 TCP 监听端口',
  'pages.CustomClient.Disable user account': '禁用用户账户',
  'pages.CustomClient.Some note about this configuration': '关于此配置的注意事项',
  'pages.CustomClient.Custom server': '自定义服务器',
  'pages.CustomClient.Visual': '视觉',
  'pages.CustomClient.Application icon': '应用图标',
  'pages.CustomClient.Security': '安全',
  'pages.CustomClient.Preset password': '预设密码',
  'pages.CustomClient.Advanced': '高级',
  'pages.CustomClient.Override settings': '覆盖设置',
  'pages.CustomClient.Default settings': '默认设置',
  'pages.CustomClient.Note: ': '注意：',
  'pages.CustomClient.Click or drag to upload': '点击或拖拽上传',
  'pages.CustomClient.app_icon_desc_tip': '上传一个512x512像素的正方形PNG图像作为应用图标。',
  'pages.CustomClient.app_name_desc_tip': '指定一个唯一的名称，显示在开始菜单、控制面板等安装的RustDesk客户端上。',
  'pages.CustomClient.logo_desc_tip': '上传一个PNG图像，显示在自定义客户端的主窗口顶部。大小会自动缩放。我们建议使用200x40像素的PNG。',
  'pages.CustomClient.This password will be used as a default permanent password for all new clients. It can be changed by the client.': '此密码将作为所有新客户端的默认永久密码。可以通过客户端更改。',
  'pages.CustomClient.Preset password is set.': '已设置预设密码。',
  'pages.CustomClient.Change password': '修改密码',
  'pages.CustomClient.Keep current password': '保留当前密码',
  'pages.CustomClient.The application icon must be a PNG file.': '应用图标必须是一个PNG文件。',
  'component.tagSelect.expand': '展开',
  'component.tagSelect.collapse': '收起',
  'component.tagSelect.all': '全部',
  'component.LicenseAlert.Your license is invalid.': '许可证无效',
  'component.LicenseAlert.Your license is not set.': '尚未设置许可证',
  'component.LicenseAlert.Your license is about to expire in 2 weeks.': '许可证将在两周内过期',
  'component.LicenseAlert.Your license has expired.': '许可证已过期',
  'pages.CustomClient.Refresh status manually': '手动刷新状态',
  'pages.CustomClient.the building task': '构建任务',
  'pages.CustomClient.Stop': '停止',
  'pages.CustomClient.Cancel': '取消',
  'pages.CustomClient.Completed at %s, this file will be deleted in 1 day.': '完成于 %s，此文件将在1天后删除。',

  'component.globalHeader.search': '站内搜索',
  'component.globalHeader.help': '使用文档',
  'component.globalHeader.notification': '通知',
  'component.globalHeader.notification.empty': '你已查看所有通知',
  'component.globalHeader.message': '消息',
  'component.globalHeader.message.empty': '您已读完所有消息',
  'component.globalHeader.event': '待办',
  'component.globalHeader.event.empty': '你已完成所有待办',
  'component.noticeIcon.clear': '清空',
  'component.noticeIcon.cleared': '清空了',
  'component.noticeIcon.empty': '暂无数据',
  'component.noticeIcon.view-more': '查看更多',
  'Token List': '令牌列表',
  Description: '描述',
  'Device Permission': '设备权限',
  'Audit Log Permission': '审计日志权限',
  'User Permission': '用户权限',
  'Group Permission': '群组权限',
  'Strategy Permission': '策略权限',
  'Address Book Permission': '地址簿权限',

  'menu.welcome': '欢迎',
  'menu.more-blocks': '更多区块',
  'menu.home': '首页',
  'menu.admin': '管理页',
  'menu.admin.sub-page': '二级管理页',
  'menu.login': '登录',
  'menu.register': '注册',
  'menu.register-result': '注册结果',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表单页',
  'menu.form.basic-form': '基础表单',
  'menu.form.step-form': '分步表单',
  'menu.form.step-form.info': '分步表单（填写转账信息）',
  'menu.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.form.step-form.result': '分步表单（完成）',
  'menu.form.advanced-form': '高级表单',
  'menu.list': '列表页',
  'menu.list.audit-list': '安全审计',
  'menu.list.audit-list.Alarm': '风险/异常报警',
  'menu.list.audit-list.Connection': '连接日志',
  'menu.list.audit-list.File': '文件传输日志',
  'menu.list.audit-list.Console': '控制台操作日志',
  'menu.list.device-list': '设备',
  'menu.list.user-list': '用户',
  'menu.list.group-list': '群组',
  'menu.list.group-list.user': '用户组',
  'menu.list.group-list.device': '设备组',
  'menu.list.role-list': '角色',
  'menu.list.role-list.admin': '管理员角色',
  'menu.list.role-list.control': '主控角色',
  'menu.list.table-list': '查询表格',
  'menu.list.basic-list': '标准列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（项目）',
  'menu.list.search-list.applications': '搜索列表（应用）',
  'menu.profile': '详情页',
  'menu.profile.basic': '基础详情页',
  'menu.profile.advanced': '高级详情页',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.settings': '个人设置',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
  'menu.editor': '图形编辑器',
  'menu.editor.flow': '流程编辑器',
  'menu.editor.mind': '脑图编辑器',
  'menu.editor.koni': '拓扑编辑器',
  'menu.Settings': '设置',
  'menu.Strategy': '策略',
  'menu.Settings.Key': '密钥',
  'menu.Settings.License': '证书',
  'menu.Settings.Relay': '中继管理',
  'menu.Settings.Others': '其它',
  'menu.Settings.Tokens': '令牌 (Token)',
  'menu.Address Books': '地址簿',
  'menu.Strategies': '策略',
  'menu.Custom Clients': '定制客户端',

  'pages.login.accountLogin.tab': '账户密码登录',
  'pages.login.accountLogin.errorMessage': '错误的用户名或者密码',
  'pages.login.failure': '登录失败，请重试！',
  'pages.login.success': '登录成功！',
  'pages.login.username.placeholder': '用户名: admin or user',
  'pages.login.username.required': '用户名是必填项！',
  'pages.login.password.placeholder': '密码: ant.design',
  'pages.login.password.required': '密码是必填项！',
  'pages.login.phoneLogin.tab': '手机号登录',
  'pages.login.phoneLogin.errorMessage': '验证码错误',
  'pages.login.phoneNumber.placeholder': '请输入手机号！',
  'pages.login.phoneNumber.required': '手机号是必填项！',
  'pages.login.phoneNumber.invalid': '不合法的手机号！',
  'pages.login.captcha.placeholder': '请输入验证码！',
  'pages.login.captcha.required': '验证码是必填项！',
  'pages.login.phoneLogin.getVerificationCode': '获取验证码',
  'pages.getCaptchaSecondText': '秒后重新获取',
  'pages.login.rememberMe': '自动登录',
  'pages.login.forgotPassword': '忘记密码 ?',
  'pages.login.submit': '登录',
  'pages.login.loginWith': '其他登录方式 :',
  'pages.login.loginWithGoogle': '使用 Google 登录',
  'pages.login.loginWithGithub': '使用 Github 登录',
  'pages.login.loginWithOkta': '使用 Okta 登录',
  'pages.login.loginWith.requesting_auth': '正在请求授权页面',
  'pages.login.loginWith.waiting_auth': '请完成账户授权',
  'pages.login.registerAccount': '注册账户',
  'pages.welcome.advancedComponent': '高级表格',
  'pages.welcome.link': '欢迎使用',
  'pages.welcome.advancedLayout': '高级布局',
  'pages.welcome.alertMessage': '更快更强的重型组件，已经发布。',
  'pages.account.tfaComponent.Enable 2FA': '启用 2FA',
  'pages.account.tfaComponent.2 Factor Authentication is enabled.': '双因素身份认证已启用',
  'pages.account.tfaComponent.Your 2FA key has been in use for an extended period. We recommend updating your 2FA key to ensure maximum account security.': '您的 2FA 密钥已使用很长时间。我们建议更新您的 2FA 密钥以确保最大账户安全。',
  'pages.account.tfaComponent.Enable 2 Factor Authentication.': '启用双因素身份认证',
  'pages.account.tfa.The code must be 6, 8, 10 digits.': '验证码必须为6、8或10位数字。',
  'pages.account.tfa.The code must be 6 or 8 digits.': '验证码必须为6或8位数字。',
  'pages.admin.subPage.title': ' 这个页面只有 admin 权限才能查看',
  'pages.admin.subPage.alertMessage': 'umi ui 现已发布，欢迎使用 npm run ui 启动体验。',
  'pages.AuditList.FileAuditList.files': '个文件',
  'pages.AuditList.FileAuditList.pathTip': '被控设备上的路径',
  'pages.AuditList.FileAuditList.limitedTip': '显示最大的10个文件',
  'pages.AuditList.FileAuditList.exportFilename': '文件传输日志',
  'pages.AuditList.ConnAuditList.modal_title': '确认操作',
  'pages.AuditList.ConnAuditList.diconnect_confirm_tip': '是否确实要断开此设备?',
  'pages.AuditList.ConnAuditList.disconnect_succ': '断开成功!',
  'pages.AuditList.ConnAuditList.disconnect_fail': '断开失败!',
  'pages.AuditList.ConnAuditList.exportFilename': '连接日志',
  'pages.AuditList.AlarmAuditList.Login Device / Local Device': '登录设备 / 主控设备',
  'pages.AuditList.AlarmAuditList.Login Account / Remote Device': '登录账户 / 被控设备',
  'pages.AuditList.AlarmAuditList.Login Account': '登录账户',
  'pages.AuditList.AlarmAuditList.Device ID': '设备ID',
  'pages.AuditList.AlarmAuditList.Device Name': '设备用户名',
  'pages.AuditList.AlarmAuditList.Remote Device': '被控设备',
  'pages.AuditList.AlarmAuditList.Event Time': '发生时间',
  'pages.AuditList.AlarmAuditList.IP whiltelist': '白名单外的IP尝试访问',
  'pages.AuditList.AlarmAuditList.ExceedThirtyAccessAttempts': '连续30次尝试访问',
  'pages.AuditList.AlarmAuditList.MultipleAccessAttemptsWithinOneMinute': '1分钟内多次尝试访问',
  'pages.AuditList.AlarmAuditList.ExceedThirtyLoginAttempts': '连续30次尝试登录',
  'pages.AuditList.AlarmAuditList.MultipleLoginsAttemptsWithinOneMinute': '1分钟内多次尝试登录',
  'pages.AuditList.AlarmAuditList.MultipleLoginsAttemptsWithinOneHour': '1小时内多次尝试登录',
  'pages.AuditList.AlarmAuditList.ExceedIPv6PrefixAttempts': '单一 IPv6 前缀连续访问尝试过多',
  'pages.AuditList.AlarmAuditList.TerminalOsLoginBackoff': '终端（以管理员身份运行）多次登录失败（用户名或密码错误）',
  'pages.AuditList.AlarmAuditList.TerminalOsLoginConcurrency': '同时多个终端（以管理员身份运行）登录尝试',
  'pages.AuditList.AlarmAuditList.exportFilename': '风险异常报警日志',
  'pages.AuditList.ConsoleAuditList.Operation': '操作',
  'pages.AuditList.ConsoleAuditList.Name': '名称',
  'pages.AuditList.ConsoleAuditList.Name list': '名称列表',
  'pages.AuditList.ConsoleAuditList.ID list': 'ID列表',
  'pages.AuditList.ConsoleAuditList.Result': '结果',
  'pages.AuditList.ConsoleAuditList.Remote': '被控端',
  'pages.AuditList.ConsoleAuditList.Local': '主控端',
  'pages.AuditList.ConsoleAuditList.User Login': '用户登录控制台',
  'pages.AuditList.ConsoleAuditList.Add Group': '新建群组',
  'pages.AuditList.ConsoleAuditList.Add User': '添加用户',
  'pages.AuditList.ConsoleAuditList.Add Device': '添加设备',
  'pages.AuditList.ConsoleAuditList.Delete Groups': '批量删除群组',
  'pages.AuditList.ConsoleAuditList.Disconnect Device': '断开设备连接',
  'pages.AuditList.ConsoleAuditList.Enable Users': '使能用户',
  'pages.AuditList.ConsoleAuditList.Disable Users': '禁用用户',
  'pages.AuditList.ConsoleAuditList.Enable Devices': '批量使能设备',
  'pages.AuditList.ConsoleAuditList.Disable Devices': '批量禁用设备',
  'pages.AuditList.ConsoleAuditList.Update Group': '更新群组',
  'pages.AuditList.ConsoleAuditList.Update User': '更新用户',
  'pages.AuditList.ConsoleAuditList.Update Device': '更新设备',
  'pages.AuditList.ConsoleAuditList.Delete User': '删除用户',
  'pages.AuditList.ConsoleAuditList.Delete Device': '删除设备',
  'pages.AuditList.ConsoleAuditList.Add Address Book': '添加地址簿',
  'pages.AuditList.ConsoleAuditList.Delete Address Book': '删除地址簿',
  'pages.AuditList.ConsoleAuditList.Change Address Book Name': '更改地址簿名称',
  'pages.AuditList.ConsoleAuditList.Group Management': '群组管理',
  'pages.AuditList.ConsoleAuditList.User Management': '用户管理',
  'pages.AuditList.ConsoleAuditList.Device Management': '设备管理',
  'pages.AuditList.ConsoleAuditList.Address Book Management': '地址簿管理',
  'pages.AuditList.ConsoleAuditList.exportFilename': '控制台日志',
  'pages.AuditList.ConsoleAuditList.Delete Devices in the Address Book Recycle Bin': '从地址簿回收站中删除设备',
  'pages.AuditList.ConsoleAuditList.Empty Address Book Recycle Bin': '清空地址簿回收站',
  'pages.AuditList.ConsoleAuditList.Add Address Book Permission': '添加地址簿权限',
  'pages.AuditList.ConsoleAuditList.Delete Address Book Permission': '删除地址簿权限',
  'pages.AuditList.ConsoleAuditList.Update Address Book Permission': '修改地址簿权限',
  'pages.Settings.Strategy.Strategy list': '策略列表',
  'pages.Settings.Strategy.Automatically close incoming sessions on user inactivity': '用户不活动时自动关闭入站会话',
  'pages.Settings.Strategy.delete_strategy_tip': '确定要删除该策略吗?',
  'pages.Settings.Strategy.New strategy': '新建策略',
  'pages.Settings.Strategy.Rename strategy': '重命名策略',
  'pages.Settings.Strategy.Duplicate strategy': '复制策略',
  'pages.Settings.Strategy.Edit Devices': '编辑设备',
  'pages.Settings.Strategy.Edit Users': '编辑用户',
  'pages.Settings.Strategy.Rename': '重命名',
  'pages.Settings.Strategy.Duplicate': '复制',
  'pages.Settings.Strategy.Delete': '删除',
  'pages.Settings.Strategy.Groups': '群组',
  'pages.Settings.Strategy.Select All': '全选',
  'pages.Settings.Strategy.Permissions': '权限',
  'pages.Settings.Strategy.Password': '密码',
  'pages.Settings.Strategy.Security': '安全',
  'pages.Settings.Strategy.Other': '其它',
  'pages.Settings.Strategy.IP whitelist': 'IP白名单',
  'pages.Settings.Strategy.Cancel': '取消',
  'pages.Settings.Strategy.Submit': '确定',
  'pages.Settings.Strategy.Edit': '编辑',
  'pages.Settings.Strategy.Custom': '自定义',
  'pages.Settings.Strategy.Full access': '完全访问',
  'pages.Settings.Strategy.Screen share': '仅共享屏幕',
  'pages.Settings.Strategy.Enable keyboard/mouse': '允许控制键盘/鼠标',
  'pages.Settings.Strategy.Enable remote printer': '允许远程打印',
  'pages.Settings.Strategy.Enable clipboard': '允许同步剪切板',
  'pages.Settings.Strategy.Enable file transfer': '允许传输文件',
  'pages.Settings.Strategy.Enable audio': '允许传输音频',
  'pages.Settings.Strategy.Enable camera': '允许查看摄像头',
  'pages.Settings.Strategy.Enable terminal': '允许终端',
  'pages.Settings.Strategy.Enable TCP tunneling': '允许建立TCP隧道',
  'pages.Settings.Strategy.Enable remote restart': '允许远程重启',
  'pages.Settings.Strategy.Enable recording session': '允许录制会话',
  'pages.Settings.Strategy.Enable blocking user input': '允许阻止用户输入',
  'pages.Settings.Strategy.Enable privacy mode': '允许隐私模式',
  'pages.Settings.Strategy.Enable remote configuration modification': '允许远程修改配置',
  'pages.Settings.Strategy.Permission type': '权限类型',
  'pages.Settings.Strategy.Approve mode': '认证方式',
  'pages.Settings.Strategy.Password type': '密码类型',
  'pages.Settings.Strategy.Hide connection management window': '隐藏连接管理窗口',
  'pages.Settings.Strategy.One-time password length': '一次性密码长度',
  'pages.Settings.Strategy.Numeric one-time password': '一次性密码为数字',
  'pages.Settings.Strategy.Accept sessions via password': '只允许密码访问',
  'pages.Settings.Strategy.Accept sessions via click': '只允许点击访问',
  'pages.Settings.Strategy.Accept sessions via both': '允许密码或点击访问',
  'pages.Settings.Strategy.Use one-time password': '使用一次性密码',
  'pages.Settings.Strategy.Use permanent password': '使用固定密码',
  'pages.Settings.Strategy.Use both passwords': '同时使用两种密码',
  'pages.Settings.Strategy.Deny LAN discovery': '拒绝局域网发现',
  'pages.Settings.Strategy.Enable direct IP access': '允许IP直接访问',
  'pages.Settings.Strategy.auto_disconnect_option_tip': '自动关闭不活跃的会话',
  'pages.Settings.Strategy.deny_lan_discovery_desc_tip': '设备将不会被同一局域网内的其他设备发现',
  'pages.Settings.Strategy.enable_direct_ip_access_desc_tip': '允许直接IP连接到设备',
  'pages.Settings.Strategy.Remove wallpaper during incoming sessions': '接受会话时移除桌面壁纸',
  'pages.Settings.Strategy.minutes': '分钟',
  'pages.Settings.Strategy.Enable': '启用',
  'pages.Settings.Strategy.Disable': '禁用',
  'pages.Settings.Strategy.disabled': '禁用',
  'pages.Settings.Strategy.Default': '默认策略',
  'pages.Settings.Strategy.Apply changes of this page': '应用本页更改',
  'pages.Settings.Strategy.Invalid IP': '无效 IP',
  'pages.Settings.Strategy.IP Whitelisting': 'IP 白名单',
  'pages.Settings.Strategy.Clear': '清空',
  'pages.Settings.Strategy.OK': '确认',
  'pages.Settings.Strategy.whitelist_sep': '可以使用逗号，分号，空格或者换行符作为分隔符',
  'pages.Settings.Strategy.Use IP whitelisting': '只允许白名单上的 IP 访问',
  'pages.Settings.Strategy.whitelist_tip': '只有白名单里的 IP 才能访问本机',
  'pages.CustomClient.bidirectional_desc_tip': '创建一个客户端，可以连接另一台设备，也可以接收连接请求',
  'pages.CustomClient.incoming_desc_tip': '创建一个客户端，只能接收连接请求',
  'pages.CustomClient.outgoing_desc_tip': '创建一个客户端，可以连接另一台设备',
  'pages.CustomClient.disable_installation_desc_tip': '禁止用户安装自定义客户端（仅限Windows）',
  'pages.CustomClient.disable_settings_desc_tip': '禁用用户访问自定义客户端的设置',
  'pages.CustomClient.disable_ab_desc_tip': '禁用自定义客户端中的地址簿功能',
  'pages.CustomClient.disable_tcp_desc_tip': '启动RustDesk时避免Windows防火墙对话框, 这个将跳过P2P直连尝试, 直接使用中继连接',
  'pages.CustomClient.disable_account_desc_tip': '移除用户在RustDesk客户端中登录的功能',
  'pages.CustomClient.override_settings_desc_tip': '覆盖设置，无法在RustDesk中更改',
  'pages.CustomClient.default_settings_desc_tip': '更改RustDesk默认使用的默认设置',
  'pages.Settings.KeyPage.failedToFetchKey': '获取密钥失败。',
  'pages.Settings.KeyPage.keyResetSuccess': '密钥重置成功，请重启hbbr以使更改生效。',
  'pages.Settings.KeyPage.errorResettingKey': '重置密钥时发生错误。',
  'pages.Settings.KeyPage.keyUpdateSuccess': '密钥更新成功，请重启hbbr以使更改生效。',
  'pages.Settings.KeyPage.errorUpdatingKey': '更新密钥时发生错误，请检查密钥',
  'pages.Settings.KeyPage.key': '密钥',
  'pages.Settings.KeyPage.privateKey': '私钥',
  'pages.Settings.KeyPage.publicKey': '公钥',
  'pages.Settings.KeyPage.editKey': '更新密钥',
  'pages.Settings.KeyPage.reset': '重置',
  'pages.Settings.KeyPage.custom': '手动输入',
  'pages.Settings.KeyPage.pleaseInputPrivateKey': '请输入您的私钥！',
  'pages.Settings.License.settingsUpdatedSuccess': '设置成功更新。',
  'pages.Settings.License.licenseCannotBeEmpty': '证书不能为空。',
  'pages.Settings.License.license': '许可证',
  'pages.Settings.Relay.GeoOverrideDescription': '只有当存在多个中继服务器时，才能使用位置覆写功能。',
  'pages.Settings.GeoOverride.ipOrDomain': 'IP/域名',
  'pages.Settings.GeoOverride.latitude': '纬度',
  'pages.Settings.GeoOverride.longitude': '经度',
  'pages.Settings.GeoOverride.deleteSelectedConfirm': '确定要删除选中的位置覆写吗？',
  'pages.Settings.GeoOverride.deleteConfirm': '确定要删除该位置覆写吗？',
  'pages.Settings.GeoOverride.editGeoOverride': '编辑覆写',
  'pages.Settings.GeoOverride.addGeoOverride': '添加覆写',
  'pages.Settings.GeoOverride.ipOrDomainRequired': 'IP/域名不能为空。',
  'pages.Settings.GeoOverride.latitudeRequired': '纬度不能为空。',
  'pages.Settings.GeoOverride.longitudeRequired': '经度不能为空。',
  'pages.Settings.GeoOverride.testGeo': '测试位置',
  'pages.Settings.GeoOverride.geofileFetchFailed': '获取GeoFile信息失败。',
  'pages.Settings.GeoOverride.loadGeoOverrides': '加载覆写',
  'pages.Settings.GeoOverride.geoOverride': '位置覆写',
  'pages.Settings.GeoOverride.title': '位置覆写',
  'pages.Settings.GeoOverride.RelaySettings': '设置',
  'pages.Settings.GeoOverride.RelayServers': '中继服务器',
  'pages.Settings.GeoOverride.AddServer': '添加服务器',
  'pages.Settings.GeoOverride.AlwaysUseRelay': '始终使用中继',
  'pages.Settings.GeoOverride.UpdateServers': '导入修改',
  'pages.Settings.GeoOverride.UpdatedAlwaysUseRelay': '已更新始终使用中继',
  'pages.Settings.GeoOverride.FailedToUpdateAlwaysUseRelay': '更新始终使用中继失败',
  'pages.Settings.GeoOverride.UpdatedRelayServers': '已更新中继服务器',
  'pages.Settings.GeoOverride.FailedToUpdateRelayServers': '更新中继服务器失败',
  'pages.Settings.GeoOverride.UpdatedChangeIDSetting': '已更新更改ID设置',
  'pages.Settings.GeoOverride.FailedToUpdateChangeIDSetting': '更新更改ID设置失败',
  "pages.Settings.Others.Allow change ID": "允许更改ID",
  "pages.Settings.Others.Disable new devices": "禁用新设备",
  "pages.Settings.Others.Require deployment for new devices": "新设备必须部署后注册",
  "pages.Settings.Others.deployment_required_tip": "启用后，新设备必须运行 `rustdesk --deploy --token <api_token>` 才能注册到此服务器。",
  "pages.Settings.Others.Login is required on the control end before access": "控制端登录后才能发起连接",
  "pages.Settings.Others.access_require_login_license_tip": "并发连接数受限的许可证始终要求开启",
  "pages.Settings.Others.Only admin can access unassigned devices": "只用管理员可以访问未分配的设备",
  "pages.Settings.Others.Allow non-admin to share address books to other groups": "允许非管理员分享地址簿到其他组",
  'pages.Settings.OIDC.Maximum Number of Authorized Users': '最多认证用户数',
  'pages.Settings.OIDC.emptyPrompt': '当前没有第三方认证提供者，请添加一个以使用此功能。',
  'pages.Settings.OIDC.confirm-delete-title': '确认删除',
  'pages.Settings.OIDC.confirm-delete-content': '相关的第三方授权用户无法再登录。您可以进入用户管理界面删除这些用户。',
  'pages.Settings.OIDC.Use Avatar': '使用头像',
  'pages.Settings.OIDC.use_avatar_tip': '在创建新用户时同步头像。',
  'pages.Settings.OIDC.oidc_map_groups_tooltip': '启用组映射后，用户将在首次登录时添加到相应的用户组。后续登录不会更新其用户组。如果用户属于多个组，则只会将其添加到一个组中。',
  'pages.Settings.Others.Only admin can access logs': '只有管理员可以访问未分配的日志',
  'pages.Welcome.Max Devices': '最大设备数',
  'pages.Welcome.Max Users': '最大用户数',
  'pages.Welcome.Not set': '未设置',
  'pages.Welcome.Invalid': '无效',
  'pages.Welcome.Demo': '试用',
  'pages.Welcome.Personal': '个人',
  'pages.Welcome.Business': '商业',
  'pages.Welcome.Unknown': '其它',
  'pages.Welcome.Max Peers': '最大设备数',
  'pages.Welcome.RustDesk Server Status': 'RustDesk 服务器状态',
  'pages.Welcome.Concurrent Connections': '并发连接数',
  'pages.Welcome.License Expire Time': '许可证到期时间',
  'pages.Welcome.Document': '文档',
  'pages.Welcome.Config': '配置',
  'pages.Welcome.Windows EXE': 'Windows EXE',
  'pages.Welcome.Mobile QR Code': '移动端二维码',
  'pages.AddressBook.Permission': '权限',
  'pages.AddressBook.Device count': '设备数量',
  'pages.AddressBook.Address Books': '地址簿',
  'pages.AddressBook.Tags': '标签',
  'pages.AddressBook.Devices': '设备',
  'pages.AddressBook.Device': '设备',
  'pages.AddressBook.Alias': '别名',
  'pages.AddressBook.Whether a password is set': '是否设置了密码',
  'pages.AddressBook.Recycle Bin': '回收站',
  'pages.AddressBook.Empty Recycle Bin': '清空回收站',
  'pages.AddressBook.Personal': '个人',
  'pages.AddressBook.Personal (My address book)': '个人（我的地址簿）',
  'pages.AddressBook.Shared': '共享',
  'pages.AddressBook.Share': '共享',
  'pages.AddressBook.Delete': '删除',
  'pages.AddressBook.Settings': '设置',
  'pages.AddressBook.Owner': '所有者',
  'pages.AddressBook.My Permission': '我的权限',
  'pages.AddressBook.Read-only': '只读',
  'pages.AddressBook.Read/Write': '读写',
  'pages.AddressBook.Full Control': '完全控制',
  'pages.AddressBook.share_warning_tip': '上述字段是共享的并且对其他人可见。',
  'pages.AddressBook.permission_tip': '只读：可以查看设备和标签；读/写：可以编辑设备和标签；完全控制：可以重新共享、删除或重命名地址簿。',
  'pages.AddressBook.rule_priority_tip': '优先级: 用户 > 群组 > 所有人',
  'Remove password': '删除密码',
  'pages.AddressBook.Import': '导入',
  'pages.AddressBook.Filter by intersection': '按交集过滤',
  'pages.AddressBook.Permissions': '权限',
  'pages.AddressBook.Type': '类型',
  'pages.AddressBook.Untagged': '无标签',

  'app.pwa.offline': '当前处于离线状态',
  'app.pwa.serviceworker.updated': '有新内容',
  'app.pwa.serviceworker.updated.hint': '请点击"刷新"按钮或者手动刷新页面',
  'app.pwa.serviceworker.updated.ok': '刷新',

  'app.setting.pagestyle': '整体风格设置',
  'app.setting.pagestyle.dark': '暗色菜单风格',
  'app.setting.pagestyle.light': '亮色菜单风格',
  'app.setting.content-width': '内容区域宽度',
  'app.setting.content-width.fixed': '定宽',
  'app.setting.content-width.fluid': '流式',
  'app.setting.themecolor': '主题色',
  'app.setting.themecolor.dust': '薄暮',
  'app.setting.themecolor.volcano': '火山',
  'app.setting.themecolor.sunset': '日暮',
  'app.setting.themecolor.cyan': '明青',
  'app.setting.themecolor.green': '极光绿',
  'app.setting.themecolor.daybreak': '拂晓蓝（默认）',
  'app.setting.themecolor.geekblue': '极客蓝',
  'app.setting.themecolor.purple': '酱紫',
  'app.setting.navigationmode': '导航模式',
  'app.setting.sidemenu': '侧边菜单布局',
  'app.setting.topmenu': '顶部菜单布局',
  'app.setting.fixedheader': '固定 Header',
  'app.setting.fixedsidebar': '固定侧边菜单',
  'app.setting.fixedsidebar.hint': '侧边菜单布局时可配置',
  'app.setting.hideheader': '下滑时隐藏 Header',
  'app.setting.hideheader.hint': '固定 Header 时可配置',
  'app.setting.othersettings': '其他设置',
  'app.setting.weakmode': '色弱模式',
  'app.setting.copy': '拷贝设置',
  'app.setting.copyinfo': '拷贝成功，请到 config/defaultSettings.js 中替换默认配置',
  'app.setting.production.hint':
    '配置栏只在开发环境用于预览，生产环境不会展现，请拷贝后手动修改配置文件',

  'app.settings.menuMap.basic': '基本设置',
  'app.settings.menuMap.security': '安全设置',
  'app.settings.menuMap.binding': '账号绑定',
  'app.settings.menuMap.notification': '新消息通知',
  'app.settings.basic.avatar': '头像',
  'app.settings.basic.change-avatar': '更换头像',
  'app.settings.basic.email': '邮箱',
  'app.settings.basic.email-message': '请输入您的邮箱!',
  'app.settings.basic.nickname': '昵称',
  'app.settings.basic.nickname-message': '请输入您的昵称!',
  'app.settings.basic.profile': '个人简介',
  'app.settings.basic.profile-message': '请输入个人简介!',
  'app.settings.basic.profile-placeholder': '个人简介',
  'app.settings.basic.country': '国家/地区',
  'app.settings.basic.country-message': '请输入您的国家或地区!',
  'app.settings.basic.geographic': '所在省市',
  'app.settings.basic.geographic-message': '请输入您的所在省市!',
  'app.settings.basic.address': '街道地址',
  'app.settings.basic.address-message': '请输入您的街道地址!',
  'app.settings.basic.phone': '联系电话',
  'app.settings.basic.phone-message': '请输入您的联系电话!',
  'app.settings.basic.update': '更新基本信息',
  'app.settings.security.strong': '强',
  'app.settings.security.medium': '中',
  'app.settings.security.weak': '弱',
  'app.settings.security.password': '账户密码',
  'app.settings.security.password-description': '当前密码强度',
  'app.settings.security.phone': '密保手机',
  'app.settings.security.phone-description': '已绑定手机',
  'app.settings.security.question': '密保问题',
  'app.settings.security.question-description': '未设置密保问题，密保问题可有效保护账户安全',
  'app.settings.security.email': '备用邮箱',
  'app.settings.security.email-description': '已绑定邮箱',
  'app.settings.security.mfa': 'MFA 设备',
  'app.settings.security.mfa-description': '未绑定 MFA 设备，绑定后，可以进行二次确认',
  'app.settings.security.modify': '修改',
  'app.settings.security.set': '设置',
  'app.settings.security.bind': '绑定',
  'app.settings.binding.taobao': '绑定淘宝',
  'app.settings.binding.taobao-description': '当前未绑定淘宝账号',
  'app.settings.binding.alipay': '绑定支付宝',
  'app.settings.binding.alipay-description': '当前未绑定支付宝账号',
  'app.settings.binding.dingding': '绑定钉钉',
  'app.settings.binding.dingding-description': '当前未绑定钉钉账号',
  'app.settings.binding.bind': '绑定',
  'app.settings.notification.password': '账户密码',
  'app.settings.notification.password-description': '其他用户的消息将以站内信的形式通知',
  'app.settings.notification.messages': '系统消息',
  'app.settings.notification.messages-description': '系统消息将以站内信的形式通知',
  'app.settings.notification.todo': '待办任务',
  'app.settings.notification.todo-description': '待办任务将以站内信的形式通知',
  'app.settings.open': '开',
  'app.settings.close': '关',
  'app.copyright.produced': '由 RustDesk 团队开发',
  'pages.account.Settings.Security.Password': '密码',
  'pages.account.Settings.Security.Change password': '修改密码',
  'pages.account.tfa.Enable 2FA': '启用 2FA',
  'pages.account.tfa.2 Factor Authentication is enabled.': '双因素身份认证已启用',
  'pages.account.tfa.Your 2FA key has been in use for an extended period. We recommend updating your 2FA key to ensure maximum account security.': '您的 2FA 密钥已使用很长时间。我们建议更新您的 2FA 密钥以确保最大账户安全。',
  'pages.account.tfa.Enable 2 Factor Authentication.': '启用双因素身份认证',

  'Enable Two-Factor Authentication': '启用双因素认证',
  'Make your RustDesk account more secure by requiring an extra authentication code when you log in.': '通过要求在登录时输入额外的认证验证码，使您的 RustDesk 账户更加安全。',
  '1. Download an authenticator app': '1. 下载一个认证器应用',
  'Download an authenticator app such as': '下载一个认证器应用，如 Google Authenticator 或 Authy',
  '2FA code': '2FA 验证码',
  'Authenticator': '认证器',
  'on your phone or desktop.': '在您的手机或桌面上。',
  '2. Scan the QR code': '2. 扫描二维码',
  'Open your authenticator app, scan the QR code and enter the code that your app shows.': '打开您的认证器应用，扫描二维码并输入应用显示的验证码。',
  'You can change or remove 2FA at any time in your account settings.': '您可以随时在账户设置中更改或删除 2FA。',
  'Please verify your 2FA code to disable current 2FA first.': '请先验证您的 2FA 验证码以禁用当前的 2FA。',
  'Can\'t verify the code. Check that code and local time settings are correct!': '验证码有误。请检查验证码和本地时间设置是否正确！',
  'First sign-in:': '首次登录：',
  'Recent activity:': '最近活动：',
  'pages.Settings.GeoOverride.reloadGeo': '重新加载地理位置数据',
  'pages.Settings.GeoOverride.getRelayServer': '获取中继服务器',
  'pages.Settings.GeoOverride.relayServer': '中继服务器',
  'SMTP Host': 'SMTP 主机',
  'SMTP Port': 'SMTP 端口',
  'My Server Requires Authentication': '我的服务器需要身份验证',
  'smtp.From': '发件人',
  'Mail Account': '邮件账户',
  'Mail Password': '邮件密码',
  'Client secrets have an expiration date. Set a calendar reminder before it expires to avoid service interruption.':
    'Client Secret 有过期时间，请在到期前设置日历提醒以避免服务中断。',
  'Custom Certificate PEM File Path (on the server)': '自定义证书 PEM 文件路径（在服务器上）',
  'Timeout (Seconds)': '超时（秒）',
  Update: '更新',
  'Submit and Test Email': '提交并测试邮件',
  'he Receiver Email': '接收者邮箱',
  'LDAP Host': 'LDAP 主机',
  'LDAP Port': 'LDAP 端口',
  'Filter': '过滤器',
  'Username Attribute': '用户名属性',
  'The attribute used as the username when logging in. Default is "dn".': '登录时使用的属性。默认值为 "dn"',
  'DraggableTab.Drag tab to reorder': '拖动标签以重新排序',
  'pages.Settings.OIDC.new.Auth Type': '认证类型',
  'pages.Settings.OIDC.New Auth Provider': '新建认证提供者',
  'pages.Settings.OIDC.new.New Auth Provider': '新建认证提供者',
  'pages.Settings.OIDC.Delete This Provider': '删除此提供者',
  'pages.Settings.OIDC.new.Enable PKCE': '启用 PKCE',
  'pages.Settings.OIDC.Enable PKCE': '启用 PKCE',
  'pages.Settings.OIDC.new.Timeout(seconds) to force a refresh of metadata(e.g. JWKS) from OIDC providers': '超时（秒）强制刷新 OIDC 提供者的元数据（例如 JWKS）',
  'pages.Settings.OIDC.new.0 means no timeout, empty means default (3600)': '0 表示没有超时，空表示默认（3600）',
  'Callback URL': '回调 URL',
  'pages.Settings.Others.Session expiration time (Days)': '会话过期时间 (天)',
  'pages.Settings.Others.2FA Issuer Name': '2FA 发行者名称',
  'pages.Settings.Others.tfa_issuer_tip': '自定义扫描 2FA 二维码时在认证器应用中显示的名称，最终显示为「<名称> Login」。默认为 RustDesk。',
  'pages.Settings.Others.idp_allow_local_password_login': '允许 IdP（OIDC）用户使用本地密码登录',
  'Or': '或者',
  'transfer_address_book': '转移地址簿',
  'transfer_address_book_confirm': '您确定要转移此地址簿吗？',
  'add_devices': '添加设备',
  'add_users': '添加用户',
  'move_to': '移动到',
  'Username': '用户名',
  'audit_retention_days': '日志保留 (天)',
  'audit_retention_days_tip': '输入 0 以无限期保留所有日志。输入大于 0 的数字以自动删除指定天数之前的日志。清理每小时运行一次。',
  "set_password": "设置密码",
  'disable_read_accessible': '禁用获取可访问的设备',
  'disable_read_accessible_tip': '当这个选项被打开时，RustDesk 客户端将无法获取可访问的设备。',
  'default_shared_password': '默认共享密码',
  'default_shared_password_tip': '地址簿级别的共享密码: 如果此地址簿中的设备没有设置共享密码，则此密码将用作共享密码。',
  'used_user': '已使用/最大用户数',
  'used_device': '已使用/最大设备数',
  'days': '天',
  'hours': '小时',
  'minutes': '分钟',
  'just now': '刚刚',
  'Offline': '离线',
  'Online': '在线',
  'last_online_sort_tip': '在线排序仅在过滤后的设备数 ≤ 2000 时可用。',
  'last_online': '最后在线时间',
  'OS': '操作系统',
  'batch_delete_device_tooltip': '只有禁用和离线的设备可以批量删除。确认对话框中的 ID 是最后一个选中的设备 ID。',
  'batch_delete_device_tooltip_deployment': '只有禁用的设备可以批量删除（部署模式下允许删除在线设备）。确认对话框中的 ID 是最后一个选中的设备 ID。',
  'More': '更多',
  'login_verification': '登录验证',
  'reset_2fa': '重置 2FA 配置',
  'disable_email_login_verification': '禁用 Email 登录验证',
  'reset_2fa_confirm': '重置所选用户的 2FA？',
  'disable_email_login_verification_confirm': '确定要禁用所选用户的邮箱登录验证吗？',
  'login_verification_column_tip': '如果同时启用了 2FA 和邮箱验证，将优先使用 2FA。',
  'reset_2fa_tip': '将向用户邮箱发送通知（如果已设置邮箱）。重置后：若用户被强制使用 2FA 登录，下次登录时需重新设置 2FA；若用户未被强制使用 2FA 登录，下次登录时将无需验证 2FA。',
  'disable_email_login_verification_tip': '将向用户邮箱发送通知。禁用后，用户下次登录时将不再需要邮箱验证。',
  'disable_in_account_setting_tip': '请前往账户设置中禁用您自己的登录验证。',
  'enable_2fa_enforcement': '强制启用 2FA 登录',
  'disable_2fa_enforcement': '取消强制启用 2FA 登录',
  'enable_2fa_enforcement_confirm': '确定要强制用户使用 2FA 登录吗？',
  'disable_2fa_enforcement_confirm': '确定要取消强制用户使用 2FA 登录吗？',
  '2fa_enforcement_enable_tip': '将向用户邮箱发送通知（如果已设置邮箱）。启用后，用户下次登录时必须完成 2FA 设置，否则无法登录。',
  '2fa_enforcement_disable_tip': '将向用户邮箱发送通知（如果已设置邮箱）。取消后，用户仍可使用 2FA，但不再是必需的。',
  'enforce_2fa_alert': '管理员要求您完成双因素认证后才能继续使用。',
  'backup_codes_desc': '如果您无法使用常规的双因素认证方式，可使用备用验证码。请妥善保存这些验证码。',
  'setup_2fa_success_alert': '2FA 设置成功。请下载备用验证码并返回登录页面。',
  '2fa_activation_status': '2FA 激活状态',
  '2fa_enforcement_status': '2FA 强制状态',
  '2fa_enforced_and_active': '2FA 已强制并激活',
  '2fa_enforced_but_pending': '2FA 已强制，但用户配置尚未完成',
  '2fa_not_enforced_but_active': '2FA 未强制，但已激活',
  'force_logout': '强制登出',
  'force_logout_tip': '这将使用户在所有设备上登出。',
  'force_logout_current_session_tip': '当前会话不会被登出。',
  'new_user_enforce_tfa': '强制新用户启用 2FA',
  'new_user_enforce_tfa_tip': '开启后，新用户在首次登录时必须完成 2FA 设置。',
  'confirm_disable_2fa_title': '确认禁用 2FA',
  'confirm_disable_2fa_tip': '您的账户被强制要求使用 2FA 登录。禁用后，下次登录仍需重新设置 2FA。确定要继续吗？',
  'reset_password': '重置密码',
  'assign_devices': '分配设备',
  'email_login_verification_enabled': '邮箱登录验证已启用',
  'user_status': '用户状态',
  'user_status_active': '用户已激活。',
  'user_status_disabled': '用户已被禁用。',
  'user_status_pending': '已发送邀请，等待用户接受。',
  'resend_invitation': '用户尚未接受邀请，你可以重新发送。',
  'email_login_verification_status': '邮箱登录验证状态',
  'set_tags': '设置标签',
  'set_note': '设置备注',
  'remove_all_tags': '移除所有标签',
  'no_tags_available': '没有可用标签',
  'remove_note': '移除备注',
  'set_to_selected_tags': '设置为选中标签',
  'add_selected_tags': '添加选中标签',
  'remove_selected_tags': '移除选中标签',
  'clear_all_tags': '清除所有标签',
  'Operation': '操作',
  'Tags': '标签',
  'Duration': '时长',
  'user_group_permission': '用户组权限',
  'device_group_permission': '设备组权限',
  'user_create_permission_title': '创建用户',
  'user_invite_permission_title': '邀请用户',
  'user_delete_permission_title': '删除用户',
  'user_enable_disable_permission_title': '启用/禁用用户',
  'user_manage_2fa_permission_title': '管理双因素认证',
  'Enable/Disable': '启用/禁用',
  'Assign to User': '分配给用户',
  'Edit Info': '编辑信息',
  'Edit Email': '编辑邮箱',
  'Edit Password': '编辑密码',
  'Edit Note': '编辑备注',
  'Display Name': '显示名称',
  'Edit Display Name': '编辑显示名称',
  'Manage 2FA': '管理双因素认证',
  'Force Logout': '强制登出',
  'permission_column_header_tooltip': '任何编辑权限都包含查看权限。',
  'user_column_header_tooltip': '非管理员用户无法操作管理员账户',
  'create_role': '创建角色',
  'delete_role': '删除角色',
  'update_role': '更新角色',
  'create_admin_role': '创建管理员角色',
  'delete_admin_role': '删除管理员角色',
  'update_admin_role': '更新管理员角色',
  'add_users_to_admin_role': '将用户添加到管理员角色',
  'remove_users_from_admin_role': '从管理员角色中移除用户',
  'Role Name': '角色名称',
  'Role name': '角色名称',
  'Optional note': '可选备注',
  'Create Role': '创建角色',
  'Edit Role': '编辑角色',
  'Overview': '概览',
  'Role List': '角色列表',
  'Permissions': '权限',
  'User Count': '用户数量',
  Users: '用户',
  Devices: '设备',
  'User Groups': '用户组',
  'Device Groups': '设备组',
  'Logs': '安全审计',
  'Strategies': '策略',
  'Custom Clients': '自定义客户端',
  'View': '查看',
  'admin_not_restricted_by_roles': '管理员不受角色限制，但可以为管理员分配角色。',
  'Roles': '角色',
  'Selected permissions': '已选择权限',
  'Auto-add recommended permissions': '自动添加推荐的权限',
  'Groups': '组',
  'Global': '全局',
  'Individual': '个人',
  'Group Scoped': '组范围',
  'Scope': '作用范围',
  'Unassigned devices': '未分配设备',
  'Update Group': '更新组',
  'Update Strategy': '更新策略',
  'View Devices': '查看设备',
  'View Users': '查看用户',
  'View Device Groups': '查看设备组',
  'Edit Devices': '编辑设备',
  'Edit Users': '编辑用户',
  'Edit Device Groups': '编辑设备组',

  'view_users_permission_description_global': '读取所有用户的列表信息。',
  'user_create_permission_description_global': '直接创建非管理员用户。',
  'user_invite_permission_description_global': '通过电子邮件邀请用户。',
  'user_delete_permission_description_global': '删除任何非管理员用户。用户必须先禁用才能删除。',
  'user_enable_disable_permission_description_global': '启用或禁用任何非管理员用户。',
  'user_edit_email_permission_description_global': '更改任何非管理员用户的电子邮件。',
  'user_edit_password_permission_description_global': '更改任何非管理员用户的密码。',
  'user_edit_note_permission_description_global': '更改任何非管理员用户的备注。',
  'user_edit_display_name_permission_description_global': '更改任何非管理员用户的显示名称。',
  'user_manage_2fa_permission_description_global': '管理任何非管理员用户的登录验证。包括启用/禁用 2FA 强制执行、重置 2FA 配置、禁用电子邮件登录验证。',
  'user_force_logout_permission_description_global': '强制任何非管理员用户从所有设备上注销。',
  'user_change_group_permission_description_global': '更改任何非管理员用户的组',
  'user_change_strategy_permission_description_global': '更改任何非管理员用户的策略',
  'user_change_control_role_permission_description_global': '更改任何非管理员用户的主控角色',

  'view_users_permission_description_group_scoped': '读取选定用户组内用户的列表信息。',
  'user_create_permission_description_group_scoped': '在选定用户组内创建非管理员用户。',
  'user_invite_permission_description_group_scoped': '在选定用户组内通过电子邮件邀请用户。',
  'user_delete_permission_description_group_scoped': '删除选定用户组内的非管理员用户。用户必须先禁用才能删除。',
  'user_enable_disable_permission_description_group_scoped': '启用或禁用选定用户组内的非管理员用户。',
  'user_edit_email_permission_description_group_scoped': '更改选定用户组内非管理员用户的电子邮件。',
  'user_edit_password_permission_description_group_scoped': '更改选定用户组内非管理员用户的密码。',
  'user_edit_note_permission_description_group_scoped': '更改选定用户组内非管理员用户的备注。',
  'user_edit_display_name_permission_description_group_scoped': '更改选定用户组内非管理员用户的显示名称。',
  'user_manage_2fa_permission_description_group_scoped': '管理选定用户组内非管理员用户的登录验证。包括启用/禁用 2FA 强制执行、重置 2FA 配置、禁用电子邮件登录验证。',
  'user_force_logout_permission_description_group_scoped': '强制选定用户组内的非管理员用户从所有设备上注销。',
  'user_change_strategy_permission_description_group_scoped': '更改选定用户组内非管理员用户的策略。',
  'user_change_control_role_permission_description_group_scoped': '更改选定用户组内非管理员用户的主控角色。',

  'view_devices_permission_description_global': '读取所有设备的列表信息。',
  'device_enable_disable_permission_description_global': '启用或禁用任何设备。',
  'device_delete_permission_description_global': '删除任何设备。设备必须先禁用才能删除。',
  'device_edit_info_permission_description_global': '编辑任何设备的设备名称、设备用户名（设备的系统用户名，不是 RustDesk 用户名）和备注。',
  'device_assign_to_user_permission_description_global': '将任何设备分配给任何用户。',
  'device_change_group_permission_description_global': '更改任何设备的组',
  'device_change_strategy_permission_description_global': '更改任何设备的被控策略',

  'view_devices_permission_description_group_scoped': '读取当前角色管理的设备列表信息。',
  'device_enable_disable_permission_description_group_scoped': '启用或禁用当前角色管理的设备。',
  'device_delete_permission_description_group_scoped': '删除当前角色管理的设备。设备必须先禁用才能删除。',
  'device_edit_info_permission_description_group_scoped': '编辑当前角色管理的设备名称、设备用户名（设备的系统用户名，不是 RustDesk 用户名）和备注。',
  'device_change_strategy_permission_description_group_scoped': '更改当前角色管理的设备的被控策略。',

  'view_devices_permission_description_individual': '读取用户的设备列表信息。',
  'device_enable_disable_permission_description_individual': '启用或禁用用户的设备。',
  'device_delete_permission_description_individual': '删除用户的设备。设备必须先禁用才能删除。',
  'device_edit_info_permission_description_individual': '编辑用户的设备名称、设备用户名（设备的系统用户名，不是 RustDesk 用户名）和备注。',
  'device_change_strategy_permission_description_individual': '更改用户的设备的被控策略。',

  'view_user_groups_permission_description_global': '读取所有用户组的列表信息。如果具有"查看用户"权限，则可以查看组成员。如果具有"更新用户组"权限，可以在此批量更新用户的组。',
  'edit_user_groups_permission_description_global': '创建、编辑和删除用户组，不包括更新组成员。',

  'view_device_groups_permission_description_global': '读取所有设备组的列表信息。如果具有"查看设备"权限，则可以查看组成员。如果具有"更新设备组"权限，可以在此批量更新设备的组。',
  'edit_device_groups_permission_description_global': '创建、编辑和删除设备组，不包括更新组成员。包含更新被控策略权限。',
  'device_group_change_strategy_permission_description_global': '更改任何设备组的被控策略',

  'view_audits_permission_description_global': '读取所有日志。可以编辑备注。 即使启用了“仅管理员可以访问日志”选项。',
  'edit_audits_permission_description_global': '可以断开任何活动连接。',

  'view_audits_permission_description_individual': '读取个人日志。可以编辑备注。即使启用了“仅管理员可以访问日志”选项。',
  'edit_audits_permission_description_individual': '可以断开个人活动连接。',

  'view_strategies_permission_description_global': '读取任何策略。如果具有"查看用户"、"查看设备"和"查看设备组"权限，则可以读取用户、设备和设备组的策略。如果具有"更新用户策略"、"更新设备策略"和"更新设备组策略"权限，可以在此批量更新相应的策略。',
  'edit_strategies_permission_description_global': '创建、编辑和删除策略，不包括更新用户、设备和设备组的策略。',

  'view_control_roles_permission_description_global': '读取任何主控角色。如果具有"查看用户"权限，则可以读取用户的主控角色。如果具有"更新用户主控角色"权限，可以在此批量更新相应的主控角色。',
  'edit_control_roles_permission_description_global': '创建、编辑和删除主控角色，不包括更新用户的主控角色。',

  'view_custom_clients_permission_description': '读取自定义客户端列表。可以下载已编译的自定义客户端。无法读取自定义客户端的详细配置。',
  'edit_custom_clients_permission_description': '创建、编辑和删除自定义客户端。',

  'global_type_description': '用于管理整个系统中的所有用户、设备和其他资源。',
  'individual_type_description': '用于管理分配给用户的个人设备和日志。',
  'group_scoped_type_description': '用于管理特定用户组内的用户，以及分配给这些用户的设备或属于特定设备组的设备。',

  'user_groups_scope_description': '管理选中的用户组内的用户，以及分配给这些用户的设备。',
  'device_groups_scope_description': '管理选中的设备组内的设备。',
  'unassigned_devices_scope_description': '管理未分配的设备（不属于任何用户也不属于任何设备组）。',

  'sync_device_name_with_hostname': '将设备名称与计算机主机名同步',
  'allow_device_name_change_tip': '启用后，设备名称将与计算机主机名同步。通过网页控制台、命令行或 API 进行的手动修改，可能会在客户端重启或服务重启后被覆盖。',

  'Keyboard/Mouse': '键盘/鼠标',
  'Remote Printer': '远程打印机',
  'Clipboard': '剪贴板',
  'Audio': '音频',
  'Camera': '摄像头',
  'TCP Tunnel': 'TCP隧道',
  'Remote Restart': '远程重启',
  'Recording Session': '录制会话',
  'Block User Input': '阻止用户输入',
  'Remote Configuration Modification': '远程配置修改',
  'Control Role': '主控角色',
  'Control Roles': '主控角色',
  'Admin Roles': '管理员角色',
  'create_control_role': '创建主控角色',
  'update_control_role': '更新主控角色',
  'delete_control_role': '删除主控角色',
  'assign_users_to_control_role': '将用户分配到主控角色',
  'remove_users_from_control_role': '从主控角色中移除用户',
  'Admin Role': '管理员角色',
  'Administrator': '管理员',
  'Update Control Role': '更新主控角色',
  'not_logged_control_role_description': '当控制端未登录时应用。',
  'default_control_role_description': '应用于未分配任何特定控制角色的用户。',
  'control_role_not_set': '使用客户端设置',
  'control_role_enable': '启用',
  'control_role_disable': '禁用',
  'Remove': '移除',
  'Admin Role Permission': '管理员角色权限',
  'Control Role Permission': '主控角色权限',
  'Click to view users': '点击查看用户',
  'Click to assign users': '点击分配用户',
  'Assign Users': '分配用户',

  'Added successfully': '添加成功',
  'Adding failed, please try again!': '添加失败，请重试！',
  'Update is successful': '更新成功',
  'Update failed, please try again!': '更新失败，请重试！',
  'Deletion is successful': '删除成功',
  'Deletion failed, please try again!': '删除失败，请重试！',
  'Allow': '允许',
  'Disallow': '不允许',
  'Allowed': '已允许',
  'Disallowed': '已禁止',
  'Allow connections within group': '允许群组内连接',
  'Allow connections to other groups': '允许连接到其他群组',
  'Allow connections from other groups': '允许来自其他群组的连接',
  'Allow connections from user groups': '允许来自用户群组的连接',
  'Allow connections from users': '允许来自用户的连接',
  'user groups': '用户群组',
  'users': '用户',
  'other groups': '其他群组',
  'Select a group': '选择群组',
  'Select a user': '选择用户',
  'new version available': '新版本可用',
  'Config & QR code && Windows EXE': '配置 & 二维码 & Windows EXE',
  'Server': '服务器',
  'API': 'API',
};
